import { lazy } from 'react';
import { isChunkLoadError } from './chunkLoadError';

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const getReloadKey = (chunkId) => `ltPhoenix:chunkReloaded:${chunkId}`;

const hasReloadedForChunk = (chunkId) => {
  try {
    return sessionStorage.getItem(getReloadKey(chunkId)) === '1';
  } catch (e) {
    return false;
  }
};

const markReloadedForChunk = (chunkId) => {
  try {
    sessionStorage.setItem(getReloadKey(chunkId), '1');
  } catch (e) {
    // no-op
  }
};

export const lazyWithRetry = (
  importer,
  chunkId,
  { retries = 2, retryDelayMs = 300, hardReload = true } = {}
) =>
  lazy(async () => {
    let lastError;
    for (let attempt = 0; attempt <= retries; attempt += 1) {
      try {
        return await importer();
      } catch (error) {
        lastError = error;
        if (!isChunkLoadError(error) || attempt === retries) {
          break;
        }
        await wait(retryDelayMs * (attempt + 1)); // simple backoff
      }
    }
    if (
      hardReload &&
      isChunkLoadError(lastError) &&
      !hasReloadedForChunk(chunkId)
    ) {
      markReloadedForChunk(chunkId);
      window.location.reload();
      return new Promise(() => {}); // prevent immediate rethrow during reload
    }
    throw lastError;
  });
